export default "__VITE_PUBLIC_ASSET__2183af1e__"